import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

function JsonUpload({ onUpload }) {
	const fileInputRef = useRef(null);
	const [error, setError] = useState(null);

	function handleClick() {
		setError(null);
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
			fileInputRef.current.click();
		}
	}

	function handleFileChange(e) {
		setError(null);
		const file = e.target.files?.[0];
		if (!file) return;

		if (!file.name.endsWith('.json')) {
			setError('Only .json files are accepted');
			return;
		}

		const reader = new FileReader();
		reader.onload = (event) => {
			try {
				const parsed = JSON.parse(event.target.result);
				onUpload(parsed);
			} catch (err) {
				setError('Invalid JSON file: ' + err.message);
			}
		};
		reader.onerror = () => {
			setError('Failed to read file');
		};
		reader.readAsText(file);
	}

	return (
		<div className="dsv-json-upload" style={{ display: 'inline-block' }}>
			<input
				ref={fileInputRef}
				type="file"
				accept=".json"
				style={{ display: 'none' }}
				onChange={handleFileChange}
				data-testid="json-upload-input"
			/>
			<button
				type="button"
				className="dsv-btn dsv-btn--ghost"
				onClick={handleClick}
				title="Upload JSON schema file"
			>
				Upload JSON
			</button>
			{error && (
				<p className="dsv-json-upload__error" style={{ color: '#dc2626', fontSize: 12, marginTop: 4 }} data-testid="json-upload-error">
					{error}
				</p>
			)}
		</div>
	);
}

JsonUpload.propTypes = {
	onUpload: PropTypes.func.isRequired,
};

export default JsonUpload;
